import ApplicationController from '../application_controller'

class ImageController extends ApplicationController {
  static values = {
    "src": String
  }

  connect() {
    let position = this.srcValue.lastIndexOf(".");
    let img_src = this.srcValue.substr(0, position);

    this.findImage(img_src);
  }

  checkImageSrc = async (src) => {
    return new Promise((resolve, _reject) => {
      let image = new Image();

      image.onload = async () => resolve(true);
      image.onerror = async () => resolve(false);

      image.src = src;
    })
  }

  findImage = async (img_src) => {
    for (const ext of ['.png', '.jpg', '.jpeg']) {
      const url_image = img_src + ext;
      let isLoaded = await this.checkImageSrc(url_image).then((result) => {
        return result;
      });
      if (isLoaded) {
        this.element.src = url_image;
        break;
      }
    }
  }
}

export default ImageController
